import { render, staticRenderFns } from "./preset.vue?vue&type=template&id=01393376"
import script from "./preset.vue?vue&type=script&lang=js"
export * from "./preset.vue?vue&type=script&lang=js"
import style0 from "./preset.vue?vue&type=style&index=0&id=01393376&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports